import React from "react";
import { useTranslation } from "react-i18next";

const StudyClippingButton = ({ viewportIndex, handleClippingStudy, loaderRunning, usgAgentEnabled, isCreatingMaskingProfile }) => {
  const { t } = useTranslation();
  return (
    <div>
    <span
    onClick={() => handleClippingStudy(viewportIndex, usgAgentEnabled)}
      title= {t("react-study-clipping.study-masking-button")}
      style={{ opacity: loaderRunning || isCreatingMaskingProfile ? 0.4 : 1, pointerEvents: loaderRunning || isCreatingMaskingProfile ? "none" : "auto" }}
    >
      <span className={`clipping-image-button ${loaderRunning || isCreatingMaskingProfile ? 'disabled' : ''}`} > </span>
    </span>
    </div>
  );
};

export default StudyClippingButton;
